'use strict';

+function () {
    'use strict';

    angular.module('bg.spreadit').service("Spreadit", ['$rootScope', service]);

    function service($rootScope) {}
}();